module.exports = __webpack_public_path__ + "static/media/financeIco_Selected.b4bfaec1.svg";